import { api } from '@/lib/api';
import { getAccounts } from '@/features/accounts/api';
import type {
  InstallationQualificationAccountOption,
  InstallationQualificationDetail,
  InstallationQualificationsFilters,
  InstallationQualificationsResponse,
} from './types';

export async function fetchInstallationQualifications(
  filters: InstallationQualificationsFilters = {},
): Promise<InstallationQualificationsResponse> {
  return api.get<InstallationQualificationsResponse>(
    '/v4/installation-qualifications',
    filters as Record<string, unknown>,
  );
}

export async function fetchInstallationQualification(
  id: string,
): Promise<InstallationQualificationDetail> {
  const response = await api.get<{ installationQualification: InstallationQualificationDetail }>(
    `/v4/installation-qualifications/${id}`,
  );
  return response.installationQualification;
}

export async function fetchInstallationQualificationAccounts(): Promise<InstallationQualificationAccountOption[]> {
  const pageLength = 100;
  const first = await getAccounts({
    pageNumber: 0,
    pageLength,
    status: 'active',
  });

  const accounts = [...first.accounts];
  if (first.total > pageLength) {
    const totalPages = Math.ceil(first.total / pageLength);
    const rest = await Promise.all(
      Array.from({ length: totalPages - 1 }, (_, index) =>
        getAccounts({
          pageNumber: index + 1,
          pageLength,
          status: 'active',
        }),
      ),
    );
    for (const page of rest) {
      accounts.push(...page.accounts);
    }
  }

  return accounts.map((account) => ({
    id: account.id,
    name: account.name,
    accountNumber: account.account_number ?? null,
  }));
}
